import React, { useState } from 'react';
import './FAQ.css';
import AnimatedSection from '../AnimatedSection';
import { X, Plus } from '@phosphor-icons/react';

const faqs = [
  {
    q: 'What is WeSplit used for?',
    a: 'WeSplit helps you split expenses, share costs, and send payments with friends in a simple and social way — using crypto for instant settlement.'
  },
  {
    q: 'Do my friends need to use WeSplit too?',
    a: 'Yes — everyone joins the same group to track, approve, and split expenses together.'
  },
  {
    q: 'Is WeSplit safe to use?',
    a: 'Yes. WeSplit uses multi-signature wallets so no one can move group funds alone.'
  },
  {
    q: 'Is WeSplit free?',
    a: 'Yes — you only pay standard blockchain transaction fees.'
  },
  {
    q: 'Do I need crypto experience to use it?',
    a: 'Not at all — WeSplit works just like a normal payment app. Crypto runs quietly in the background.'
  },
  {
    q: 'What can I use WeSplit for?',
    a: 'Trips, rent, events, shared purchases, or everyday expenses with friends.'
  },
  {
    q: 'Which blockchain does WeSplit use?',
    a: 'WeSplit is built on Solana for fast, low-cost payments.'
  },
  {
    q: 'Can I use WeSplit with a large group or community?',
    a: 'Yes — from small friend groups to teams and DAOs, WeSplit scales with your needs.'
  }
];

function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="faq-section" id="faq">
      <div className="faq-wrapper">
      <AnimatedSection animationType="slide-up">
        <div className="faq-header">
          <h2 className="lp-section-title">Everything You <span className="lp-section-title-highlight">Need to</span> <span className="lp-section-title-highlight">Know</span> About WeSplit</h2>
          <p className="lp-section-subtitle">Built for simple, secure, and social group payments on crypto rails.</p>
        </div>
      </AnimatedSection>
      <div className="faq-list">
        {faqs.map((item, i) => (
          <AnimatedSection key={i} animationType="slide-up" stagger={i + 1} display="flex" className="faq-animated-section">
            <div className={`faq-item${open === i ? ' open' : ''}`}>
              <button className="faq-question" onClick={() => setOpen(open === i ? -1 : i)}>
                <span>{item.q}</span>
                <span className="faq-toggle">
                  {open === i ? <X weight="bold" size={20} /> : <Plus weight="bold" size={20} />}
                </span>
              </button>
              {open === i && <div className="faq-answer">{item.a}</div>}
            </div>
          </AnimatedSection>
        ))}
      </div>
      </div>
    </section>
  );
}

export default FAQ; 